module.exports = __webpack_public_path__ + "static/media/3.03206032.jpg";